@switch (uiState) {
  @case (uiStateForTemplate.ShowData) {
    @if(game!.StripeAccountType == StripeAccountType.CharityBasedConnectAccount && charity) {
      @if (charity.StripeAccountId) {
        @if(stripeAccount!.DisabledReason) {
          <div class="alert-container">
              <div class="alert-text">
                Note: this stripe account has been disabled by Stripe with the message "{{ stripeAccount!.DisabledReason | stripeDisabledReason }}" Please contact a Causable administrator if you require assistance.
              </div>
          </div>
        }
        <mat-card data-testid="charity-stripe-detail-section">
          <mat-card-content>
            <div class="detail-label">Stripe Account ID for {{ charity.Name }}</div>
            @if(charity.StripeAccountId) {
              <div class="detail-value" data-testid="charity-stripe-account-id">
                {{ charity.StripeAccountId }}
              </div>
            }
          </mat-card-content>
        </mat-card>
        @if(stripeAccountHasRequirements()) {
          <div class="alert-container requirements-container">
            <div class="alert-text">
              Stripe requires information to complete your account setup. You can click the "Complete Account Setup" button below to resolve this. Please note that if these requirements are not met soon, your Stripe account may be disabled.
            </div>
            @if(stripeAccount!.RequirementsPastDue.length > 0) {
              <h6 class="requirements-header">Requirements Past Due:</h6>
              <ul>
                @for (requirement of stripeAccount!.RequirementsPastDue; track requirement) {
                  <li
                  >{{ requirement | stripeRequirement }}</li>
                }
              </ul>
            }
            @if(stripeAccount!.RequirementsCurrentlyDue.length > 0) {
              <h6 class="requirements-header">Requirements Currently Due:</h6>
              <ul>
                @for (requirement of stripeAccount!.RequirementsCurrentlyDue; track requirement) {
                  <li
                  >{{ requirement | stripeRequirement }}</li>
                }
              </ul>
            }
            @if(stripeAccount!.RequirementsEventuallyDue.length > 0) {
              <h6 class="requirements-header">Requirements Eventually Due:</h6>
              <ul>
                @for (requirement of stripeAccount!.RequirementsEventuallyDue; track requirement) {
                  <li
                  >{{ requirement | stripeRequirement }}</li>
                }
              </ul>
            }
          </div>
          <button mat-raised-button (click)="onCompleteAccountSetup()" data-testid="complete-account-setup-button">Complete Account Setup</button>
        }
      } @else {
        <mat-card class="mb-4">
          <mat-card-content>
            <p>This charity does not have a stripe account associated with it. To begin account creation, click the button below.</p>
            <button mat-raised-button (click)="onCreateStripeAccount()" data-testid="create-stripe-account-button">Create Stripe Account</button>
          </mat-card-content>
        </mat-card>
      }
    }
  }
  @case (uiStateForTemplate.ShowLoading) {
    <mat-card class="mb-4">
      <mat-card-content>
        <mat-spinner class="center-margin"></mat-spinner>
      </mat-card-content>
    </mat-card>
  }
}
